import { useLoaderData } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { ServiceDto } from '../application/dto/ServiceDto';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import './ServiceDetailPage.css';

export function ServiceDetailPage() {
  const service = useLoaderData() as ServiceDto;
  useDocumentHead(service.seo);

  return (
    <Container>
      <article className="dma-service-detail">
        <h1>{service.title}</h1>
        <p className="dma-service-detail__summary">{service.summary}</p>
        <p className="dma-service-detail__description">{service.description}</p>
      </article>
    </Container>
  );
}
